export const isEmpty = (obj) => {
    return Object.keys(obj || {}).length === 0;
};
// keep only the specified key(s) from an object
export const objFilter = (obj, keysToKeep) => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => keysToKeep.includes(key)));
};
// remove specified key(s) from an object
export const objFilterOut = (obj, keysToRemove) => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => !keysToRemove.includes(key)));
};
/**
 * returns the object's key by it's known value.
 * If unknown, it will return the defaultKey
 */
export function getKeyByValue(obj, value, defaultKey) {
    return Object.keys(obj).find((key) => obj[key] === value) ?? defaultKey;
}
